// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { CDatePicker } from "@coreui/react-pro";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

/**
 * TODO add
 * @param locale
 * @param value
 * @param __FormItem
 * @param valid
 * @param invalid
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
const DateTime = ({ locale = "en-GB", value, __FormItem = true, valid, invalid, ...props }) => {
  const [internalValid, setInternalValid] = useState(undefined);

  useEffect(() => {
    if (valid) {
      setInternalValid(true);
    } else {
      setInternalValid(undefined);
    }
  }, [valid, invalid]);

  return (
    <>
      <CDatePicker
        {...props}
        date={value}
        valid={undefined}
        invalid={invalid}
        locale={locale}
        onDateChange={(e) => {
          console.log(e);
          if (e) {
            props.onChange(e.toISOString());
          } else {
            props.onChange("");
          }
        }}
      />
    </>
  );
};

DateTime.propTypes = {
  value: PropTypes.string,
  __FormItem: PropTypes.bool,
};

DateTime.defaultProps = {
  __FormItem: true,
};

export default DateTime;
